import React from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { About } from "@/components/About";
import { Courses } from "@/components/Courses";
import { GuidanceSessions } from "@/components/GuidanceSessions";
import { Offerings } from "@/components/Offerings";
import { Process } from "@/components/Process";
import { Testimonials } from "@/components/Testimonials";
import { InstagramSection } from "@/components/InstagramSection";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { WhatsAppCta } from "@/components/WhatsAppCta";
import { EnrollmentPopup } from "@/components/EnrollmentPopup";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App bg-[#F4EBD9] min-h-screen antialiased overflow-x-clip">
        <Navbar />
        <main>
          <Hero />
          <Ribbon />
          <About />
          <Courses />
          <GuidanceSessions />
          <Offerings />
          <Process />
          <Testimonials />
          <InstagramSection />
          <Faq />
        </main>
        <Footer />
        <WhatsAppCta />
        <EnrollmentPopup />
      </div>
    </ReactLenis>
  );
}

export default App;
